import { render, staticRenderFns } from "./AddMgtCategory.vue?vue&type=template&id=69b3482f"
import script from "./AddMgtCategory.vue?vue&type=script&lang=js"
export * from "./AddMgtCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports